<template>
  <div class="ap-sku-detail">
    <div style="padding:10px 0;background: #f2f2f2;">
      <ol class="breadcrumb ap-breadcrumb main-width">
        <li class="breadcrumb-item">搜索</li>
        <li class="breadcrumb-item active">{{this.record.genCmdtyName}}</li>
      </ol>
    </div>
    <div class="main-width" style="margin-top:36px">
      <div class="clearfix" style="position:relative">
        <div class="float-left">
          <div class="pic-box" ref="picBox">
            <div style="width:100%;height:100%;">
              <PicZoom v-show="getImgUrl(url)" :url="getImgUrl(url)" :scale="3"></PicZoom>
              <img v-show="!getImgUrl(url)" src="@assets/images/no_image_large.png" style="width:100%;height:100%;" />
            </div>
          </div>
          <div class="clearfix" style="margin-top: 15px;">
            <div class="pic-thumb">
              <a v-for="(it,idx) in pics" :key="idx" @click="changeUrl(it)">
                <img :src="getImgUrl(it)" alt />
              </a>
            </div>
          </div>
        </div>
        <div class="float-left sku-info">
          <div class="title" style="width:650px;">
            <strong>{{record.name}}</strong>
          </div>
          <div class="prop-item">
            <span>商品货号</span>
            <strong>{{record.productNumber}}</strong>
          </div>
          <div class="prop-item">
            <span>商品编号</span>
            <strong>{{record.number}}</strong>
          </div>
          <div class="line"></div>
          <div class="col-props">
            <div class="prop-item" v-for="item in record.criteriaList" :key="item.genCriSourceId">
              <span>{{item.genCriName}}</span>
              <strong v-if="item.genCriValueType == 'ENUM'">{{item.enumValueName}}</strong>
              <strong v-if="item.genCriValueType == 'STRING'">{{item.stringValue}}</strong>
              <strong v-if="item.genCriValueType == 'NUMERIC'">{{item.numberValue}}{{item.unit}}</strong>
            </div>
          </div>
          <div class="line"></div>
          <div class="prop-item price" v-show="record.price && record.price!=0">
            <span>工厂直供单价</span>
            <strong>￥{{record.price | toMoney}}</strong>
            <span>/ 件</span>
          </div>
          <br />
          <div
            class="package-info"
            ref="packageinfo"
            style="margin:0;position:relative;"
            v-if="(record.loadingPackagingList.length||record.singleOrder)&&(record.supply)&&(!record.archived)&&(record.publishState=='PUBLISHED')"
          >
            <span class="prop-item" style="position:absolute;left:0;top:-24px;color:#666;">选择交付规格</span>
            <Slider :boxWidth="400" :moveWidth="300" style="padding:0;border:none;">
              <div
                class="multi"
                v-for="item in record.loadingPackagingList"
                :key="item.uuid"
                :class="{'picked': entry.pkgUuid == item.uuid}"
                @click="entry.pkgUuid=item.uuid, entry.layQty=item.layQty"
              >
                <a class="font12">
                  <strong style="color:#f03;">{{item.layQty}}</strong>&nbsp;
                  <span style="color:#333;">{{item.layQtyUnit}}</span>
                  <div style>{{item.pkgName}}</div>
                  <div>
                    {{item.dimLen}}{{item.dimUnit}}x{{item.dimWid}}{{item.dimUnit}}
                    <br />
                    x{{item.dimHig}}{{item.dimUnit}}
                  </div>
                </a>
              </div>
              <div class="single" v-if="record.singleOrder == true" :class="{'picked': entry.pkgUuid == record.pkgUuid}" @click="entry.pkgUuid=record.pkgUuid, entry.layQty=1">
                <a class="font12">
                  <strong style="color:#f03;">1</strong>
                  <span style="color:#333;">件</span>
                  <span style="margin-top:5px;display:block;">自定义</span>
                  <span>件数</span>
                </a>
              </div>
            </Slider>
            <div style="height:90px;background:#f2f2f2;float:right;position:relative;">
              <span class="prop-item" style="position:absolute;left:0;top:-24px;color:#666;">采购数量</span>
              <div class="add-to-car" style="display:inline-block;">
                <div class="font12" style="margin-bottom:7px">已选规格</div>
                <span style="margin:8px 10px 0 0;color:#f03;">
                  <strong>{{entry.layQty}} ×</strong>
                </span>
                <InputNumber :min="1" :value.sync="qty"></InputNumber>
              </div>
            </div>
          </div>
          <button
            v-if="(!(record.loadingPackagingList.length||record.singleOrder)||(!record.supply)||(!record.price)||(record.archived))&&(record.publishState!='REVOKED')"
            class="ap-btn-darkgray"
            style="width:155px;line-height:30px;"
          >此商品暂无法供应</button>
          <button v-if="record.publishState=='REVOKED'" class="ap-btn-darkgray" style="width:155px;line-height:30px;">此商品已下架</button>
          <div
            style="font-size:14px;"
            v-if="(record.loadingPackagingList.length||record.singleOrder)&&(record.price>0)&&(record.supply)&&(!record.archived)&&(record.publishState=='PUBLISHED')"
          >
            <br />采购金额：
            <strong style="color:#f03;font-size:18px;">￥{{record.price * entry.layQty * qty | toMoney }}</strong>
            <button class="ap-btn-darkred ap-btn-middle ap-btn-red-hover1 float-right" @click="addToCart()">加入采购车</button>
          </div>
        </div>
        <div class="add-btn-wrap">
          <div class="add-btn" @click="showAddToListDialog=true">加入零件清单</div>
          <div class="add-btn">加入对比</div>
        </div>
      </div>
      <div class="desc font12">
        <div class="desc-props">
          <div>
            <label>商品UPC码</label>
            <span>{{record.upc}}</span>
            <label>包装外形尺寸</label>
            <span>{{record.pkgDimLen}} x {{record.pkgDimWid}} x {{record.pkgDimHig}} {{record.pkgDimUnit}}</span>
          </div>
          <div>
            <label>产地</label>
            <span>{{record.origin}}</span>
            <label>重量</label>
            <span>{{record.pkgWeg}} {{record.pkgWegUnit}}</span>
          </div>
          <div>
            <label>包装清单</label>
            <span>{{record.pkgDescription}}</span>
          </div>
        </div>
        <div class="desc-html" v-show="record.detail" v-html="record.detail"></div>
      </div>
      <div class="cont-item font12">
        <div class="title">
          <strong>OE号</strong>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="width:200px">制造商</th>
              <th>OE号</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(it,idx) in oeList" :key="it.id" v-show="showFullList||idx<10">
              <td>{{it.brandName}}</td>
              <td>{{it.number}}</td>
            </tr>
            <tr class="openList" @click="showFullList=!showFullList">
              <td colspan="2" v-if="oeList.length>10">
                <div v-if="!showFullList">
                  全部展开
                  <i class="fa fa-fw fa-chevron-down"></i>
                </div>
                <div v-else>
                  取消展开
                  <i class="fa fa-fw fa-chevron-down"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cont-item font12">
        <div class="title">
          <strong>适装车型</strong>
        </div>
        <div class="wrap-bordered">
          <div v-for="it1 in sortVehList" :key="it1.brandSourceId">
            <div style="padding:10px;">
              <strong style="font-size:16px;">{{it1.brandName}}</strong>
            </div>
            <table class="table table-bordered" v-for="it2 in it1.children" :key="it2.modelSourceId">
              <thead>
                <tr @click="it2.show=!it2.show">
                  <th>
                    <div class="tile tile-circle tile-sm">
                      <span v-if="it2.show" class="fas fa-angle-down"></span>
                      <span v-else class="fas fa-angle-right"></span>
                    </div>
                    <span class="model">{{it2.modelName}}</span>
                    <span v-if="it2.modelNumber">( {{it2.modelNumber}} )</span>
                  </th>
                  <th style="width:200px">
                    <span v-if="it2.show">年份</span>
                    <span v-else>{{it2.year}}</span>
                  </th>
                  <th class="text-center" style="width:100px">
                    <span v-show="it2.show">功率(KW)</span>
                  </th>
                  <th class="text-center" style="width:100px">
                    <span v-show="it2.show">马力(HP)</span>
                  </th>
                  <th class="text-center" style="width:100px">
                    <span v-show="it2.show">排量(CC)</span>
                  </th>
                </tr>
              </thead>
              <tbody v-show="it2.show">
                <tr v-for="it3 in it2.children" :key="it3.sourceId">
                  <td style="padding-left:48px;">{{it3.name}}</td>
                  <td>{{it3.years.startValue.substring(0,7)}} - {{it3.years.endValue&&it3.years.endValue.substring(0,7)}}</td>
                  <td class="text-center">{{it3.kw}}</td>
                  <td class="text-center">{{it3.hp}}</td>
                  <td class="text-center">{{it3.ccm}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="cont-item font12">
        <div class="title">
          <strong>售后保障</strong>
        </div>
        <div class="wrap-bordered"></div>
      </div>
      <div class="cont-item font12">
        <div class="title">
          <strong>品牌介绍</strong>
        </div>
        <div class="wrap-bordered"></div>
      </div>
    </div>
    <div class="scroll-action" v-if="showScrollAction">
      <div class="main-width clearfix">
        <strong class="title">{{record.name}}</strong>
        <div class="float-right font12">
          <span>单价</span>
          <strong>￥</strong>
          <strong>{{record.price | toMoney}}</strong>
          <span>/ 件</span>
          <span class="add-to-car">
            <span style="display:inline-block;margin:6px 10px 0 0;color:#f03">
              <strong>{{this.entry.layQty}} ×</strong>
            </span>
            <InputNumber :min="1" :value.sync="qty"></InputNumber>
            <button class="ap-btn-darkred ap-btn-middle ap-btn-red-hover1" style="margin-left:10px" @click="addToCart()">加入采购车</button>
          </span>
        </div>
      </div>
    </div>

    <AddToListDialog :commodity="record" v-if="showAddToListDialog" @close="showAddToListDialog=false"></AddToListDialog>
  </div>
</template>
<script>
import PicZoom from "vue-piczoom";
import { getPositionToBody } from "@common/utils";
import InputNumber from "@components/InputNumber.vue";
import Slider from "@components/Slider.vue";
import AddToListDialog from "./components/AddToListDialog.vue";

export default {
  components: {
    PicZoom,
    InputNumber,
    Slider,
    AddToListDialog
  },
  data() {
    return {
      url: "",
      pics: [],
      qty: 1,
      scrollOffset: -1,
      showScrollAction: false,
      record: {
        loadingPackagingList: [],
        documentList: []
      },
      oeList: [],
      vehList: [],
      sortVehList: [],
      entry: {
        commodityId: "",
        pkgUuid: "",
        layQty: 1
      },
      showAddToListDialog: false,
      showFullList: false // OE表格是否全部展开
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  watch: {
    url() {
      this.$nextTick(() => {
        let collect = this.$refs.picBox.getBoundingClientRect();
        let bigImg = document.getElementsByClassName("mouse-cover-canvas")[0];
        bigImg.style.left = collect.right + window.scrollX + 5 + "px";
        bigImg.style.top = collect.top + window.scrollY + "px";
      });
    }
  },
  created() {
    this.getData();
    this.addToHistory();
  },
  destroyed() {
    window.removeEventListener("resize", this.getScrollOffset);
    window.removeEventListener("scroll", this.scrollAction);
  },
  methods: {
    getData() {
      this.$get("dmhs/commodities/get/" + this.id)
        .then(res => {
          res.price = "";
          document.title = res.name+' 51 AUTOPARTS';
          this.entry.commodityId = res.id;
          if (res.documentList && res.documentList.length > 0) {
            this.url = res.documentList[0].fileUri;
            for (let i = 0; i < res.documentList.length; i++) {
              this.pics.push(res.documentList[i].fileUri);
            }
          }
          if (res.loadingPackagingList && res.loadingPackagingList.length > 0) {
            this.entry.pkgUuid = res.loadingPackagingList[0].uuid;
            this.entry.layQty = res.loadingPackagingList[0].layQty;
          } else {
            this.entry.pkgUuid = res.pkgUuid;
          }
          this.getOeList(res.id);
          this.getVehList(res.id);
          this.$nextTick(() => {
            this.getScrollOffset();
            window.addEventListener("resize", this.getScrollOffset);
            window.addEventListener("scroll", this.scrollAction);
          });
          this.record = res;
          return this.$post("/crms/salesQuotation/current", { commodityId: this.id });
        })
        .then(res => {
          res = res[0] || [];
          this.record.price = res.salesPrice;
        })
        .catch(err => {});
    },
    getOeList(id) {
      let query = {
        commodityEsId: id,
        type: "OEM"
      };
      this.$post("dmhs/commodities/getRefNums", query, {
        success(data) {
          this.oeList = data;
        }
      });
    },
    getVehList(id) {
      this.$post(
        "dmhs/commodities/getVehLkgs",
        { commodityEsId: id },
        {
          success(data) {
            this.vehList = data;
            this.sortVehList = this.sort(data);
          }
        }
      );
    },
    sort(data) {
      let map = {}; // 品牌id集合
      let list = []; // 处理完的数据
      data.forEach(it1 => {
        // 把品牌分类
        if (!map[it1.brandSourceId]) {
          list.push({
            brandSourceId: it1.brandSourceId,
            brandName: it1.brandName,
            children: [it1]
          });
          map[it1.brandSourceId] = it1.brandName;
        } else {
          list.forEach(it2 => {
            if (it2.brandSourceId == it1.brandSourceId) it2.children.push(it1);
          });
        }
      });
      list.forEach(it1 => {
        let map = {}; // 车型id集合
        let temp = []; // 每个车型的车款集合
        it1.children.forEach(it2 => {
          // 把每个品牌里的车型分类
          if (!map[it2.modelSourceId]) {
            temp.push({
              modelSourceId: it2.modelSourceId,
              modelName: it2.modelName,
              modelNumber: it2.modelNumber,
              children: [it2]
            });
            map[it2.modelSourceId] = it2.modelName;
          } else {
            temp.forEach(it3 => {
              if (it3.modelSourceId == it2.modelSourceId) it3.children.push(it2);
            });
          }
        });
        temp.forEach(item => {
          // 给车型的每个车款按日期排序
          item.show = false;
          item.children.sort((a, b) => {
            return new Date(a.years.startValue).getTime() - new Date(b.years.startValue).getTime();
          });
          if (item.children.length && item.children[0].modelYears) {
            let start = item.children[0].modelYears.startValue.substring(0, 7);
            let end = item.children[0].modelYears.endValue ? item.children[0].modelYears.endValue.substring(0, 7) : "";
            item.year = start + " - " + end; // 给车型加上年份
          } else {
            item.year = "";
          }
        });
        it1.children = temp;
      });
      return list;
    },
    getScrollOffset() {
      this.scrollOffset = getPositionToBody(this.$refs.packageinfo).y || -1;
    },
    scrollAction() {
      if (this.scrollOffset == -1) {
        return;
      }
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      if (scrollTop > this.scrollOffset) {
        this.showScrollAction = true;
      } else {
        this.showScrollAction = false;
      }
    },
    changeUrl(url) {
      this.url = url;
    },
    addToCart() {
      this.$store.commit("changeCart", [
        {
          fileUri: this.record.documentList ? this.getImgUrl(this.record.documentList[0].fileUri) : "",
          name: this.record.name,
          price: this.record.price,
          layQty: this.entry.layQty,
          qty: this.qty
        }
      ]);
      let params = {
        id: this.entry.commodityId,
        pkgUuid: this.entry.pkgUuid,
        qty: this.qty
      };
      this.$post("bhome/carts/save", params)
        .then(() => {
          clearTimeout(window.cartTimeoutId);
          this.$store.commit("changeShowCart", true);
          window.cartTimeoutId = setTimeout(() => {
            this.$store.commit("changeShowCart", false);
          }, 3000);
        })
        .catch(err => {});
    },
    addToHistory() {
      if (!window.refreshToken) return;
      this.$post("dmhs/histories/save", {
        commoditySrcId: this.id.split("_")[0]
      })
        .then(() => {})
        .catch(err => {});
    }
  }
};
</script>

<style lang="less">
.ap-sku-detail {
  margin-bottom: 36px;
  color: #333;
  .ap-breadcrumb {
    margin: 0 auto;
    padding: 0 10px;
  }
  .pic-box {
    width: 550px;
    height: 550px;
    border: 1px solid #e4e4e4;
    img {
      width: auto !important;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .pic-thumb {
    width: 550px;
    a {
      overflow: hidden;
      display: inline-block;
      width: 60px;
      height: 60px;
      margin: 0 9px 9px 0;
      text-align: center;
      border: 1px solid #e4e4e4;
      background: #fff;
      img {
        max-width: 100%;
        max-height: 100%;
      }
      &:hover {
        border-color: #0099d5;
      }
    }
  }
  .line {
    margin: 6px 0 15px;
    border-top: 1px dashed #e4e4e4;
  }
  .sku-info {
    margin-left: 50px;
    .title {
      font-size: 24px;
      margin-bottom: 25px;
    }
    .prop-item {
      padding-bottom: 8px;
      font-size: 12px;
      span,
      strong {
        display: inline-block;
        vertical-align: top;
      }
      span {
        margin-right: 10px;
        color: #666;
      }
    }
    .receive-addr {
      a {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
      }
    }
    .price {
      span,
      strong {
        vertical-align: middle;
      }
      strong {
        font-size: 18px;
        color: #f03;
        + span {
          margin-left: 10px;
        }
      }
    }
  }
  .picked {
    cursor: pointer;
    background: #e4e4e4 !important ;
  }
  .package-info {
    margin-top: 10px;
    > a {
      display: inline-block;
      padding: 8px 10px;
      min-width: 90px;
      border: 1px solid #e4e4e4;
      strong {
        color: #f03;
        font-size: 1rem;
      }
      span {
        color: #666;
        + span {
          display: block;
        }
      }
      + a {
        margin-left: -1px;
      }
      &:hover {
        background: #f2f2f2;
      }
    }
    > div {
      display: inline-block;
      padding: 8px 18px 11px;
      border: 1px solid #e4e4e4;
      vertical-align: top;
    }
  }
  .add-to-car {
    span,
    button {
      display: inline-block;
      vertical-align: top;
    }
    button {
      width: 110px;
      font-size: 14px;
    }
  }
  .add-btn-wrap {
    position: absolute;
    left: 0;
    bottom: -40px;
    .add-btn {
      float: left;
      margin-right: 10px;
      padding: 5px 15px;
      cursor: pointer;
      color: #666;
      border: 1px solid rgba(228, 228, 228);
      &:hover {
        color: #000;
        background: rgba(242, 242, 242);
      }
    }
  }
  .desc {
    margin-top: 66px;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    color: #666;
    .desc-props {
      padding: 20px 28px;
      background: #f2f2f2;
      label,
      span {
        display: inline-block;
        vertical-align: top;
      }
      label {
        width: 114px;
        margin-bottom: 5px;
      }
      span {
        min-width: 240px;
      }
    }
    .desc-html {
      padding: 15px;
    }
  }
  .cont-item {
    margin-top: 30px;
    .title {
      margin-bottom: 10px;
      font-size: 18px;
    }
    table thead th {
      font-weight: normal;
      background: #f6f7f9;
      color: #666;
      cursor: pointer;
    }
    .wrap-bordered {
      padding: 20px;
      border-radius: 3px;
    }
    .tile-circle {
      font-size: 18px;
      margin-right: 10px;
    }
    .model {
      font-weight: bold;
      vertical-align: middle;
    }
  }
  .scroll-action {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 15px;
    background: #f2f2f2;
    .title {
      font-size: 20px;
    }
    .float-right {
      > span,
      > strong {
        display: inline-block;
        vertical-align: middle;
        color: #666;
      }
      strong {
        margin: 0 5px 0 10px;
        font-size: 18px;
        color: #f03;
      }
    }
    .add-to-car {
      margin-left: 20px;
    }
  }
}
</style>

<style lang="less" scoped>
.single,
.multi {
  width: 100px;
  height: 90px;
  text-align: center;
  float: left;
  border: 1px solid #e4e4e4;
  padding: 5px !important;
}
.openList {
  text-align: center;
  color: #f03;
  cursor: pointer;
  &:hover {
    background: #f6f7f9;
  }
}
</style>